import { render, staticRenderFns } from "./PromoLabel.vue?vue&type=template&id=bb1dc0ca&scoped=true"
import script from "./PromoLabel.vue?vue&type=script&lang=ts"
export * from "./PromoLabel.vue?vue&type=script&lang=ts"
import style0 from "./PromoLabel.vue?vue&type=style&index=0&id=bb1dc0ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1dc0ca",
  null
  
)

export default component.exports